// extracted by mini-css-extract-plugin
export default {"details":"styles_details__PmfqH","heading":"styles_heading__K8zb0","hr":"styles_hr__Lx+wv","field":"styles_field__qidzi","fields":"styles_fields__lCiE-","form":"styles_form__JDC-t"};